<template>
  <VueTelInput
    :disabled="readonly"
    :model-value="form.phone"
    @update:modelValue="handleInput"
    ref="input"
    mode="international"
    :preferredCountries='["US","CA","GB","IL","ZA","AU"]'
    :onlyCountries='["US","CA","GB","IL","ZA","AU","UM","CL","AR","MX","GT","PA","CH","BR","PE","CR","BE","FR","LU","AN","DK","RU","KZ","PL","DE","IT","HK","SG","NZ","CN","JP","VE","AT","IN"]'
    :placeholder="placeholder"
    @click="onClick"
  ></VueTelInput>
</template>
<script setup lang="ts">
import { VueTelInput } from 'vue-tel-input'
import { inject, onBeforeUnmount, onMounted, ref } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

defineProps<{
  readonly?: boolean
  placeholder?: string
}>()

const input = ref()
const field = inject<string>('field')
const { setValue, form, setTouched } = usePaymentForm()

function handleInput(event: string | { number?: string, formatted?: string }) {
  // vue-tel-input can emit either a string or an object depending on version/configuration
  if (typeof event === 'string') {
    // Remove all non-digit characters except the leading +
    const cleaned = event.replace(/[^\d+]/g, '')
    setValue(field, cleaned)
  } else if (event && typeof event === 'object' && event.number) {
    const cleaned = event.number.replace(/[^\d+]/g, '')
    setValue(field, cleaned)
  }
}

function blur() {
  setTouched('phone')
}

// Inside a <label>, a click on the country selector is forwarded to the phone input, which closes the list.
function onClick(event: MouseEvent) {
  if ((event.target as HTMLElement | null)?.closest('.vti__dropdown')) event.preventDefault()
}

onMounted(() => {
  if (input.value?.$refs?.input) {
    input.value.$refs.input.addEventListener('blur', blur)
  }

  if (input.value?.$watch) {
    input.value.$watch('phone', (currentPhone: string) => {
      // This is used to change from local format (if it's in local format)
      // into international right away (and emit this change)
      if (currentPhone === form.value.phone || !currentPhone) return

      setValue('phone', currentPhone.replace(/ /g, ''))
    })
  }
})

onBeforeUnmount(() => {
  if (input.value?.$refs?.input) {
    input.value.$refs.input.removeEventListener('blur', blur)
  }
})
</script>

<style lang="scss">
@import 'vue-tel-input/vue-tel-input.css';
@import './ui-phone.css';

div.vue-tel-input {
  display: flex !important;
  border-radius: 4px !important;
  border-color: #ddd !important;
  box-shadow: none !important;
  flex: 1;

  .vti__dropdown {
    background: #f7f9fb;
  }
  &:focus-within {
    border-color: #15329d !important;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5) !important;
  }
}
.vue-tel-input .vti__phone {
  box-sizing: border-box;
  width: 100%;
  display: block;
  border: none;

  &:hover,
  &:focus {
    border: none;
    box-shadow: none;
  }
}
</style>
